import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { ErrorStackService } from './error-stack.service';
import { PathService } from './path.service';

@Injectable()
export class StorageHsbshareHttpMethodsService {

  constructor(private http: HttpClient, 
    private errorStack: ErrorStackService,
    private pathService: PathService) { }


  getProjects(): Promise<any> {
    const self = this;
    return new Promise((resolve, reject) => {

      self.http.get('https://hsbservices.com/api/v2/pub/project/getMMProjects')
      .subscribe(data => {
            resolve(data);
      }, error => {
          self.errorStack.append(error, true);
          reject(error);
      });
    });
  }
  ls(projectId, path): Promise<any> {

    return new Promise((resolve, reject) => {
      if(!path){
        return reject('path cannot be empty');
      }
      let params = new HttpParams().
      set('path', this.pathService.join('/projects/' ,projectId , path))
      ;

      this.http.get('https://hsbservices.com/api/v2/efs/readdir', {params: params})
      .subscribe((data: Array<any>) => {
            if(!Array.isArray(data)){
              return reject('expected an array');
            }
            data = data.reduce((acc, fileInfo) => {
              if(fileInfo.isDir){
                  acc.folders.unshift(this.pathService.join(fileInfo.path.replace('/projects/' + projectId, '') ,fileInfo.name));//insert at pos 0.
              } else {
                  acc.files.unshift(this.pathService.join(fileInfo.path.replace('/projects/' + projectId, '') , fileInfo.name));//insert at pos 0.
              }
              return acc;
            }, {files: [], folders: []});
            resolve(data);
      }, error => {
          this.errorStack.append(error, true);
          reject(error);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/storage-hsbshare-http-methods.service.ts